import { SettingConst } from '../../types';

/**
 * Setting that gates all changes related to Standardizing Order Numbers (see #feature-standardize-order-numbers)
 */
export const RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812 =
  'RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812' as SettingConst<
    'RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812',
    boolean,
    | 'RETAILER'
    | 'HOTJAR_RETAILER'
    | 'HELP_CENTER'
    | 'RETAILER_IOS'
    | 'RETAILER_ANDROID'
  >;
